// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"640":"d4c5c018803ee8751b2a","780":"ff118c4ea27eb0b2dbdd","3564":"54a926778d2107076102","5810":"b550a24d46f75f92c2d5","7471":"6423b9b898ffefeb7d1d"}[chunkId] + "";
};